// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../extract-text-webpack-plugin/loader.js??ref--10-0!../../../vue-style-loader/index.js!../../../css-loader/index.js??ref--10-2!./select2.min.css");
if(typeof content === 'string') content = [[module.id, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = require("!../../../style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../extract-text-webpack-plugin/loader.js??ref--10-0!../../../vue-style-loader/index.js!../../../css-loader/index.js??ref--10-2!./select2.min.css", function() {
			var newContent = require("!!../../../extract-text-webpack-plugin/loader.js??ref--10-0!../../../vue-style-loader/index.js!../../../css-loader/index.js??ref--10-2!./select2.min.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./~/select2/dist/css/select2.min.css
// module id = A2Qj
// module chunks = 1